'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Email = require('./Email.scss');

var _Email2 = _interopRequireDefault(_Email);

var _Templates = require('./Templates/Templates');

var _Templates2 = _interopRequireDefault(_Templates);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _coreDecorators = require('core-decorators');

var _components = require('components');

var _account = require('redux/modules/account');

var _reduxConnect = require('redux-connect');

var _auth = require('redux/modules/auth');

var _reactRedux = require('react-redux');

var _ListTemplates = require('./ListTemplates/ListTemplates');

var _ListTemplates2 = _interopRequireDefault(_ListTemplates);

var _Contactos = require('./Contactos/Contactos');

var _Contactos2 = _interopRequireDefault(_Contactos);

var _Resumen = require('./Resumen/Resumen');

var _Resumen2 = _interopRequireDefault(_Resumen);

var _File = require('./File/File');

var _File2 = _interopRequireDefault(_File);

var _channel = require('redux/modules/channel');

var _email = require('redux/modules/email');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Email = (_dec = (0, _reduxConnect.asyncConnect)([{
    key: "auth",
    promise: function promise(_ref) {
        var _ref$store = _ref.store,
            dispatch = _ref$store.dispatch,
            getState = _ref$store.getState;

        if (!(0, _auth.isLoaded)(getState())) {
            return dispatch((0, _auth.load)());
        }
        return null;
    }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
    return {
        account: state.account.data,
        auth: state.auth
    };
}, { getAccount: _account.getAccount, getTemplates: _email.getTemplates, createTemplate: _email.createTemplate, duplicateTemplate: _email.duplicateTemplate, load: _auth.load, getEmailChannel: _channel.getEmailChannel }), _dec(_class = _dec2(_class = function (_React$Component) {
    (0, _inherits3.default)(Email, _React$Component);

    function Email(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, Email);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Email.__proto__ || (0, _getPrototypeOf2.default)(Email)).call(this, props));

        _this.completeComponent = function (status) {
            _this.setState({ componentCompleted: status });
        };

        _this.selectedComponent = function (componentName) {
            _this.setState({ componentSelected: componentName });
        };

        _this.dataBetweenComponents = function (data) {
            _this.setState({ dataBetweenComponents: data });
        };

        _this.setLayoutUid = function (layout_uid) {
            _this.setState({ layout_uid: layout_uid });
        };

        _this.getData = function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(data) {
                var template_uid, created_on, account_uid, name, subject, params;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                template_uid = void 0, created_on = void 0;
                                account_uid = _this.state.account._id;
                                name = data.name;
                                subject = data.subject;

                                delete data.name;
                                // delete data.subject
                                params = {
                                    name: name,
                                    layout_uid: _this.state.layout_uid,
                                    account_uid: account_uid,
                                    properties: data,
                                    created_by: _this.state.created_byUser.email,
                                    subject: subject
                                };
                                _context.next = 8;
                                return _this.props.createTemplate(params).then(function (res) {
                                    template_uid = res[0]._id;
                                    created_on = res[0].created_on;
                                });

                            case 8:
                                _this.setState({ template_uid: template_uid, generealInformation: params });

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref2.apply(this, arguments);
            };
        }();

        _this.createTemplate = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            var template_uid, created_on, templateName, data, account_uid, name, subject, params, res;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            template_uid = void 0, created_on = void 0, templateName = void 0;
                            data = _this.state.dataToSend;
                            account_uid = _this.state.account._id;
                            name = data.name;
                            subject = data.subject;


                            delete data.name;
                            params = {
                                name: name,
                                layout_uid: _this.state.layout_uid,
                                account_uid: account_uid,
                                properties: data,
                                created_by: _this.state.created_byUser.email,
                                subject: subject
                            };

                            if (!_this.state.copied) {
                                _context2.next = 13;
                                break;
                            }

                            _context2.next = 10;
                            return _this.props.duplicateTemplate(params);

                        case 10:
                            res = _context2.sent;
                            _context2.next = 16;
                            break;

                        case 13:
                            _context2.next = 15;
                            return _this.props.createTemplate(params);

                        case 15:
                            res = _context2.sent;

                        case 16:
                            template_uid = res[0]._id;
                            created_on = res[0].created_on;
                            templateName = res[0].name;

                            _this.setState({ template_uid: template_uid, generealInformation: params, created_on: created_on, templateName: templateName });

                        case 20:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));

        _this.setDataToSendFn = function (dataToSend) {
            _this.setState({ dataToSend: dataToSend });
        };

        _this.setTemplateId = function (template_uid) {
            _this.setState({ template_uid: template_uid });
        };

        _this.senToContacts = function () {};

        _this.setCopied = function (copied) {
            _this.setState({ copied: copied });
        };

        _this.state = {
            componentCompleted: false,
            componentSelected: 'Layouts',
            account: _this.props.account,
            dataToCreateTemplate: null,
            template_uid: null,
            dataBetweenComponents: null,
            layout_uid: null,
            dataToSend: null,
            created_on: null,
            templateName: null,
            userInfo: _this.props.userInfo,
            created_byUser: _this.props.auth.data.user,
            copied: false
        };

        return _this;
    }

    (0, _createClass3.default)(Email, [{
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps) {
            if (nextProps.account && this.state.account.status == undefined) {
                this.setState({ account: nextProps.account });
            }
        }
    }, {
        key: 'render',
        value: function render() {

            if (!this.state.account.reach) {
                return null;
            }

            var account_uid = this.state.account._id;
            var options = void 0,
                components = void 0;

            if (!this.props.file) {
                options = ['Layouts', 'Contactos', 'Resumen'];
                components = [{
                    Layouts: _react2.default.createElement(_ListTemplates2.default, {
                        completeComponent: this.completeComponent,
                        accountUI: this.state.account.reach.ui,
                        completeComponentFunction: this.completeComponent,
                        setLayoutUid: this.setLayoutUid,
                        create: this.getData,
                        createTemplate: this.createTemplate,
                        setDataToSend: this.setDataToSendFn,
                        setTemplateId: this.setTemplateId,
                        setCopied: this.setCopied,
                        selectedComponent: this.selectedComponent,
                        account_uid: account_uid })
                }, {
                    Contactos: _react2.default.createElement(_Contactos2.default, { data: this.state,
                        completeComponent: this.completeComponent,
                        completeComponentFunction: this.completeComponent,
                        dataBetweenComponents: this.dataBetweenComponents
                    })
                }, {
                    Resumen: _react2.default.createElement(_Resumen2.default, { data: this.state,
                        completeComponent: this.completeComponent,
                        completeComponentFunction: this.completeComponent
                    })
                }];
            } else {
                options = ['Files', 'Layouts', 'Resumen'];
                components = [{
                    Layouts: _react2.default.createElement(_File2.default, { data: this.state,
                        completeComponent: this.completeComponent,
                        completeComponentFunction: this.completeComponent,
                        dataBetweenComponents: this.dataBetweenComponents })
                }, {
                    Layouts: _react2.default.createElement(_ListTemplates2.default, {
                        completeComponent: this.completeComponent,
                        accountUI: this.state.account.reach.ui,
                        completeComponentFunction: this.completeComponent,
                        setLayoutUid: this.setLayoutUid,
                        create: this.getData,
                        createTemplate: this.createTemplate,
                        setDataToSend: this.setDataToSendFn,
                        setTemplateId: this.setTemplateId,
                        selectedComponent: this.selectedComponent,
                        account_uid: account_uid,
                        file: true,
                        draggedFileData: this.state.dataBetweenComponents })
                }, {
                    Resumen: _react2.default.createElement(_Resumen2.default, { data: this.state,
                        completeComponent: this.completeComponent,
                        completeComponentFunction: this.completeComponent,
                        draggedFileData: this.state.dataBetweenComponents,
                        file: true
                    })
                }];
            }

            return _react2.default.createElement(
                'div',
                { className: _Email2.default.mainContainer },
                _react2.default.createElement(
                    _components.CustomWizard,
                    { options: options,
                        completeComponent: this.state.componentCompleted,
                        selectedComponent: this.selectedComponent,
                        setData: this.getData,
                        create: this.getData,
                        componentSelected: this.state.componentSelected,
                        createTemplate: this.createTemplate,
                        completeComponentFunction: this.completeComponent },
                    components
                )
            );
        }
    }]);
    return Email;
}(_react2.default.Component)) || _class) || _class);
exports.default = Email;
module.exports = exports['default'];